import React from "react";

const MatchingFormButton = (props) => {
  return (
    <div className="matching-button">
      <span
        className={
          props.formIsOpen
            ? "matching-button-bar-1 matching-button-bar-1-open"
            : "matching-button-bar-1"
        }
      ></span>
      <span
        className={
          props.formIsOpen
            ? "matching-button-bar-2 matching-button-bar-2-open"
            : "matching-button-bar-2"
        }
      ></span>
    </div>
  );
};

export default MatchingFormButton;
